var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticStyle:{"padding-top":"20px"}},[_c('p',[_vm._v("\n    Contact Support:\n    "),_c('a',{attrs:{"target":"_blank","href":_vm.mailLink}},[_vm._v(_vm._s(_vm.supportEmail))])])])}
var staticRenderFns = []

export { render, staticRenderFns }